export enum AnnouncementCategory {
  IssuerUpdate = 1,
  CorporateMatter = 2,
  MaterialAnnouncement = 3,
  OtherIssuerAnnouncement = 4,
  PstxCommunication = 5,
}

export enum AnnouncementType {
  Company = 1,
  Market = 2,
}

//PLT-1783
export enum AnnouncementAudience {
    All = 1,
    InvestorOnly = 2
}
